export type LeadStatus = "new" | "contacted" | "quoted" | "won" | "lost"

export type LeadSource =
  | "walk-in"
  | "phone"
  | "whatsapp"
  | "instagram"
  | "facebook"
  | "referral"
  | "website"
  | "prospect"
  | "other"

export interface Lead {
  id: string
  name: string
  phone: string
  city: string
  interest: string
  budget: string
  timeline: string
  source: LeadSource
  notes: string
  status: LeadStatus
  createdAt: string
  updatedAt: string
}

export type NewLeadInput = Omit<Lead, "id" | "status" | "createdAt" | "updatedAt">

export const LEAD_STATUSES: { value: LeadStatus; label: string }[] = [
  { value: "new", label: "New" },
  { value: "contacted", label: "Contacted" },
  { value: "quoted", label: "Quoted" },
  { value: "won", label: "Won" },
  { value: "lost", label: "Lost" },
]

export const LEAD_SOURCES: { value: LeadSource; label: string }[] = [
  { value: "walk-in", label: "Walk-in" },
  { value: "phone", label: "Phone Call" },
  { value: "whatsapp", label: "WhatsApp" },
  { value: "instagram", label: "Instagram" },
  { value: "facebook", label: "Facebook" },
  { value: "referral", label: "Referral" },
  { value: "website", label: "Website" },
  { value: "prospect", label: "Prospect Search" },
  { value: "other", label: "Other" },
]

export const FURNITURE_INTERESTS = [
  "Sofa",
  "Bed",
  "Dining",
  "Wardrobe",
  "Chair",
  "Tables",
  "TV Unit",
  "Modular Kitchen",
  "Safety Door",
  "Mandir",
  "Custom / Made-to-order",
  "Bulk / Institutional Order",
  "Other",
]

export const BUDGET_RANGES = [
  "Under ₹25,000",
  "₹25,000 – ₹50,000",
  "₹50,000 – ₹1,00,000",
  "₹1,00,000+",
  "Not sure yet",
]

export const TIMELINES = ["Immediate (this week)", "This month", "1–3 months", "Just exploring"]

// Common B2B categories that place bulk/institutional furniture orders - used as
// quick-pick starting points in the prospect finder's text search.
export const PROSPECT_CATEGORIES = [
  "Interior designers",
  "Architects",
  "Building contractors",
  "Real estate developers",
  "Hotels",
  "Resorts",
  "Banquet halls",
  "PG and hostels",
  "Corporate offices",
  "School and colleges",
]
